<template>
  <div class="bg-secondary min-h-screen">
    <div class="pt-32 pb-20 lg:px-48 md:px-12 px-6 max-w-4xl mx-auto">
      <h1 class="font-pt-serif text-4xl font-bold mb-8">Умови використання</h1>
      <p class="font-montserrat text-sm text-gray-400 mb-10">Останнє оновлення: 2026-08-19</p>

      <div class="prose-policy">

        <p>Використовуючи сайт <strong>osnovy.bibleawr.com</strong>, ви погоджуєтесь з цими Умовами використання. Якщо ви не погоджуєтесь — будь ласка, не використовуйте сайт.</p>

        <h2>1. Про сервіс</h2>
        <p>«Основи Віри» — безкоштовний освітній курс з вивчення Біблії, розроблений за підтримки AWR360 (Адвентистське Всесвітнє Радіо) і Bible School (Hope365). Курс доступний для всіх охочих незалежно від конфесійної приналежності.</p>

        <h2>2. Реєстрація та участь</h2>
        <p>Реєструючись на курс, ви надаєте згоду на:</p>
        <ul>
          <li>Отримання навчальних матеріалів через Telegram або WhatsApp</li>
          <li>Зв'язок з нашим служителем у навчальних цілях</li>
          <li>Обробку персональних даних відповідно до Політики конфіденційності</li>
        </ul>

        <h2>3. Безкоштовність</h2>
        <p>Курс є повністю безкоштовним. Ми не стягуємо жодної плати за участь, матеріали або консультації служителя.</p>

        <h2>4. Інтелектуальна власність</h2>
        <p>Всі матеріали курсу (тексти, відео, зображення) є власністю AWR360 / Bible School. Забороняється відтворення або розповсюдження матеріалів без письмового дозволу.</p>

        <h2>5. Відповідальність</h2>
        <p>Матеріали курсу надаються «як є» з навчальною метою. Ми не несемо відповідальності за будь-які рішення, прийняті на їх основі.</p>

        <h2>6. Зміни умов</h2>
        <p>Ми залишаємо за собою право змінювати ці умови. Про суттєві зміни ми повідомлятимемо через месенджер.</p>

        <h2>7. Контакти</h2>
        <ul>
          <li>Email: <a href="mailto:hope365ua@gmail.com">hope365ua@gmail.com</a></li>
          <li>Telegram: <a href="https://t.me/hope365ua_bot" target="_blank">@hope365ua_bot</a></li>
        </ul>

      </div>

      <div class="mt-12 pt-8 border-t border-gray-200">
        <NuxtLink :to="localePath('/')" class="font-montserrat text-sm growing-underline">
          ← На головну
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const localePath = useLocalePath()
useHead({ title: 'Умови використання — Основи Віри' })
</script>

<style scoped>
.prose-policy :deep(h2) {
  font-family: 'PT Serif', serif;
  font-size: 1.5rem;
  font-weight: 700;
  margin-top: 2.5rem;
  margin-bottom: 1rem;
}
.prose-policy :deep(p) {
  font-family: 'Montserrat', sans-serif;
  font-size: 1rem;
  line-height: 1.75;
  color: #374151;
  margin-bottom: 1rem;
}
.prose-policy :deep(ul) {
  font-family: 'Montserrat', sans-serif;
  font-size: 1rem;
  line-height: 1.75;
  color: #374151;
  padding-left: 1.5rem;
  margin-bottom: 1rem;
  list-style: disc;
}
.prose-policy :deep(a) {
  text-decoration: underline;
  color: inherit;
}
.prose-policy :deep(strong) {
  font-weight: 600;
}
</style>
